<template>
  <div id="app" class="container">
 
   	<div class="center-block text-center">
   		<img src="../build/logo.png" class="img-responsive center-block"/>
    	<h4 style="color: red;"> TodoList 点击事项即可删除</h4>
   		<h5>使用localStorage进行数据缓存</h5>
   	</div>

   
   
    <div class="text-center">
    	
    	<input  type="text" v-model="inputValue" @keyup.enter="handleClick" v-bind:placeholder="placeHolder"  />
    	<button  @click="handleClick"  class="btn btn-success">确定</button>
    </div>

    <ul class="list-group ul">
    	<todoitem 
    		@delete="handleDel"  
    		v-for="(item,index) of arr" 
    		:key="index" 
    		:content="item" 
    		:index="index"
    
    		>
    		{{item}}
    	</todoitem>
    </ul>
    
    
  </div>
</template>

<script>
	if(localStorage.getItem('todolist')===''){
				localStorage.setItem('todolist','HelloWorld');
			}
import todoitem from './components/todoitem'

export default {
  components:{
  		todoitem	
  },
  data(){
  	return {
  		placeHolder:'请填入事项，按Enter添加',
  		arr:localStorage.getItem('todolist').split(','),
  		inputValue:''
  		
  	}
  },
  methods:{
  	handleClick:function(){
  		if(this.inputValue.trim().length===0){
  			return false;
  		}
  		
  		this.arr.push(this.inputValue);
  		
			localStorage.setItem('todolist',this.arr);
  		this.inputValue=''; 
  		
  	},
  	handleDel:function(msg){
  		//alert(msg[0]);
  		
  		
  //if(confirm('确定删除吗?')){
  			this.arr.splice(msg[0],1);
  	//	}
  		
  	  localStorage.setItem('todolist',this.arr);
  	
  	}
  },
  computed:{},
  watch:{

  }
}
</script>

<style>
	ul{margin:0;padding: 0;}

</style>



// WEBPACK FOOTER //
// src/todolist.vue